import React, { useEffect, useState } from 'react';
import { ToggleSwitch, ToggleSwitchOffLabel, ToggleSwitchOnLabel } from '@vp/swan';
import { useDebugContext } from 'src/hooks/DebugContextHooks';
import { removeQueryParam } from 'src/utils/QueryStringUtil';

export const DebugToolbarToggle = () => {
  const { debugMode, setDebugMode } = useDebugContext();
  const [activated, setActivated] = useState(debugMode);

  useEffect(() => {
    if (!activated) {
      setDebugMode(false);
      window.location.href = removeQueryParam(window.location.href, 'debug');
    }
  }, [activated, setDebugMode]);
  return (
    <ToggleSwitch fontSkin="body-small-bold" activated={activated} onRequestActivatedChange={() => setActivated(false)}>
      <ToggleSwitchOnLabel>Debug&nbsp;On</ToggleSwitchOnLabel>
      <ToggleSwitchOffLabel>Debug&nbsp;Off</ToggleSwitchOffLabel>
    </ToggleSwitch>
  );
};

DebugToolbarToggle.displayName = 'DebugToolbarToggle';
